<template>
  <div class="tech-multi-check">
    <kt-autoselect
      :label="props.label"
      :options="techOptions"
      display-by="TechnicianName"
      value-by="Id"
      :multiple="true"
      v-model="model"
      search-placeholder="Search technicians..."
      :on-refresh="handleRefresh"
      @change="handleChange"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import KtAutoselect from '@/components/UI/KtAutoselect.vue';
import { useTechStore } from '@/stores/TechStore';
import type { TechnicianModel } from '@/models/TechnicianModel';

const props = defineProps({
  label: { 
    type: String, 
    default: 'Select Technicians' 
  }
});

const emit = defineEmits<{
  change: [value: number[]];
}>();

const model = defineModel<number[]>({
  default: () => []
});

const techStore = useTechStore();
const techOptions = ref<TechnicianModel[]>([]);

// Load technicians on mount
onMounted(async () => {
  const techs = await techStore.getActive();
  techOptions.value = techs || [];
});

const handleChange = (value: number[]) => {
  emit('change', value);
};

const handleRefresh = async () => {
  await techStore.refresh();
  const techs = await techStore.getActive();
  techOptions.value = techs || [];
};
</script>

